/**
 * What goes back into the composer when the server never took a message.
 *
 * The composer empties itself the moment Send is pressed. If the send then
 * fails before the server has the message — a refused attachment (type,
 * size), a request refused outright — the words the person typed would be
 * gone. The panel that sent it answers `'not_taken'`, and the composer puts
 * back what it had: the words and a reply's quotation, so fixing the
 * attachment is the only thing left to do.
 */

/** A panel's answer to a send. Anything but `'not_taken'` keeps the box clear. */
export type SendOutcome = 'not_taken' | void;

export interface ComposerDraft {
  message: string;
  quote: string | null;
}

/**
 * The draft to put back, or null: nothing when the person has already typed
 * something new while the send was refused (their new words win), or when
 * the draft had no words and no quotation (a files-only send).
 */
export function draftToRestore(sent: ComposerDraft, boxNow: string): ComposerDraft | null {
  if (boxNow.trim()) return null;
  return sent.message.trim() || sent.quote ? sent : null;
}
